import React, { useEffect, useRef, useState } from "react";
import BalloonBurst from "./BalloonBurst";

/**
 * ItemEffect — универсальный рендерер эффектов косметических предметов.
 *
 * Как добавить новый эффект:
 *   1. В админке загружаешь товар, в поле «Тег эффекта» пишешь уникальное имя,
 *      например  neon_rainbow.
 *   2. Добавляешь case в switch ниже:
 *        case 'neon_rainbow': return <NeonRainbow params={params} />;
 *   3. Пишешь компонент NeonRainbow (CSS keyframes, Lottie, SVG — что угодно).
 *   4. Деплоишь.
 *
 * Props:
 *   effectType   — строка-тег (из CosmeticItem.effect_type)
 *   effectParams — JSON-строка или объект (из CosmeticItem.effect_params)
 *   trigger      — "mount" | "click" (как эффект активируется)
 *   children     — элемент под которым рендерится эффект (overlay)
 */

function parseParams(raw) {
  if (!raw) return {};
  if (typeof raw === "object") return raw;
  try { return JSON.parse(raw); } catch { return {}; }
}

// ─── Эффект: clown_balloons ──────────────────────────────────────────────
// Красные шарики вверх при клике. params опционально: { color, count }
function ClownBalloonsEffect({ params, trigger, children }) {
  const [burstKey, setBurstKey] = useState(trigger === "mount" ? 1 : 0);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (trigger === "mount") setBurstKey(k => k + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onClick = trigger === "click" ? (e) => {
    e.stopPropagation();
    setBurstKey(k => k + 1);
  } : undefined;

  return (
    <div
      ref={wrapRef}
      onClick={onClick}
      style={{ position: "relative", display: "inline-block", width: "100%", height: "100%", cursor: trigger === "click" ? "pointer" : "default" }}
    >
      {children}
      {burstKey > 0 && (
        <BalloonBurst
          key={burstKey}
          color={params?.color || "#ef4444"}
          count={params?.count || 22}
        />
      )}
    </div>
  );
}

// ─── Главный свитчер ─────────────────────────────────────────────────────

export default function ItemEffect({ effectType, effectParams, trigger = "click", children }) {
  const params = parseParams(effectParams);

  switch (effectType) {
    case "clown_balloons":
      return (
        <ClownBalloonsEffect params={params} trigger={trigger}>
          {children}
        </ClownBalloonsEffect>
      );

    // Добавляй свои эффекты сюда:
    // case 'my_effect_tag':
    //   return <MyEffectComponent params={params}>{children}</MyEffectComponent>;

    default:
      // Неизвестный тег → просто пробрасываем детей без оболочки
      return <>{children}</>;
  }
}
